<template>
  <div class="card mb-2">
    <div class="card-body bg-secondary pt-2 pb-0 pl-1 pr-2">
      <b-form class="search-form" @submit.prevent="onSearch">
        <div class="d-flex">
          <div class="row align-items-center">
            <div class="input-wrapper" v-if="!excludeSearchFields.includes('email')">
              <input-widget :label="false" :placeholder="true" :model="searchModel" attribute="email"/>
            </div>
            <div class="input-wrapper" v-if="!excludeSearchFields.includes('first_name')">
              <input-widget :label="false" :placeholder="true" :model="searchModel" attribute="first_name"/>
            </div>
            <div class="input-wrapper" v-if="!excludeSearchFields.includes('last_name')">
              <input-widget :label="false" :placeholder="true" :model="searchModel" attribute="last_name"/>
            </div>
            <div class="input-wrapper" v-if="!excludeSearchFields.includes('rejected_by')">
              <user-select-input-widget attribute="rejected_by_uuid" @select="onRejectedBySelect"
                                        :model="searchModel"
                                        :label="false"
                                        :options="{placeholder: $t('Rejected By')}" is-search/>
            </div>
            <div class="input-wrapper" v-if="!excludeSearchFields.includes('sent_by')">
              <user-select-input-widget attribute="sent_by_uuid" @select="onSentBySelect"
                                        :model="searchModel"
                                        :label="false"
                                        :options="{placeholder: $t('Sent By')}" is-search/>
            </div>
            <div class="input-wrapper" v-if="!excludeSearchFields.includes('status')">
              <input-widget :model="searchModel"
                            attribute="status"
                            value-field="value"
                            display-field="${item.key}"
                            type="select2"
                            :label="false"
                            :options="{placeholder: $t('Status')}"
                            :items="statuses"/>
            </div>
            <div class="input-wrapper" v-if="!excludeSearchFields.includes('sale_no')">
              <input-widget :label="false" :placeholder="true" :model="searchModel" attribute="sale_no"/>
            </div>
            <div class="input-wrapper" v-if="!excludeSearchFields.includes('sale_title')">
              <input-widget :label="false" :placeholder="true" :model="searchModel" attribute="sale_title"/>
            </div>
            <div class="input-wrapper" v-if="!excludeSearchFields.includes('lot_no')">
              <input-widget :label="false" :placeholder="true" :model="searchModel" attribute="lot_no"/>
            </div>
            <div class="input-wrapper" v-if="!excludeSearchFields.includes('department')">
              <department-select-input-widget :label="false"
                                              :placeholder="true"
                                              :model="searchModel"
                                              @select="onDepartmentSelect" @unselect="onDepartmentUnselect"
                                              :options="{placeholder: $t('Department')}"
                                              attribute="department"/>
            </div>
            <div class="input-wrapper" v-if="!excludeSearchFields.includes('category')">
              <category-select-input-widget :label="false" with-all-categories
                                            :department="departmentModel"
                                            :options="{placeholder: $t('Category')}"
                                            :model="searchModel"
                                            attribute="category"/>
            </div>
          </div>
          <div class="search-btn-wrapper">
            <b-button variant="primary" @click.prevent="onResetClick">
              <font-awesome-icon icon="undo" class="icon"/>
              {{ $t('Reset') }}
            </b-button>
            <b-button type="submit" variant="primary" class="ml-2">
              <font-awesome-icon icon="search" class="icon"/>
              {{ $t('Search') }}
            </b-button>
          </div>
        </div>
      </b-form>
    </div>
  </div>
</template>

<script>
  import InputWidget from "../../core/components/input-widget/InputWidget";
  import {createNamespacedHelpers} from "vuex";
  import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
  import UserSelectInputWidget from "@/core/widgets/UserSelectInputWidget.vue";
  import DepartmentSelectInputWidget from "@/core/widgets/DepartmentSelectInputWidget.vue";
  import CategorySelectInputWidget from "@/core/widgets/CategorySelectInputWidget.vue";

  const {mapState, mapActions} = createNamespacedHelpers('conditionReportRequests');

  export default {
    name: "ConditionReportRequestSearch",
    components: {CategorySelectInputWidget, DepartmentSelectInputWidget, UserSelectInputWidget, InputWidget},
    props: {
      excludeSearchFields: {
        type: Array,
        default: () => []
      }
    },
    data (){
      return {
        departmentModel: null
      }
    },
    computed: {
      ...mapState({
        searchModel: state => state.tableData[state.tableSource].searchModel,
        extraFilters: state => state.tableData[state.tableSource].extraFilters,
        statuses: state => state.statuses
      }),
    },
    methods: {
      ...mapActions(['getTableData', 'updateSearchModel', 'resetTable', 'resetTableDataPaginationPage']),
      async onSearch() {
        await this.updateSearchModel(this.searchModel);
        this.resetTableDataPaginationPage();
        this.getTableData();
      },
      onResetClick() {
        this.resetTable();
      },
      async onRejectedBySelect(rejected_by) {
        this.updateSearchModel({rejected_by});
      },
      async onSentBySelect(sent_by) {
        this.updateSearchModel({sent_by});
      },
      onDepartmentSelect(item) {
        this.departmentModel = item;
      },
      onDepartmentUnselect() {
        this.departmentModel = null;
      }
    },
  }
</script>

<style lang="scss" scoped>
</style>
